<template>
<span>

    <form-imagem-product v-on:atualizar="atualizarProducts" :product="product"></form-imagem-product>

    <v-container fluid>
         <v-divider class="mb-6"></v-divider>
        <v-layout row wrap>

            <v-flex xs6 sm6 md4 lg3 xl2 v-for="(imagem, index) in product.fotos" :key="index" pa-2>
                <v-card>
                    <v-img class="img-preview" :src="`${base_url}upload/product_photo/q/${imagem.prod_ft_foto}`">
                    </v-img>

                    <v-card-actions class="justify-center">
                        <v-btn icon>
                            <v-icon @click.prevent="destroyProductPhoto(imagem, index)">highlight_off</v-icon>
                        </v-btn>
                        <v-divider class="mx-2" inset vertical></v-divider>
                        <v-btn icon>
                            <v-icon @click.prevent="updateCapa(imagem)" :class="{ 'is-capa': imagem.prod_ft_destaque }">star</v-icon>
                        </v-btn>

                    </v-card-actions>

                </v-card>

            </v-flex>

        </v-layout>
    </v-container>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'
import FormImagemProductComponent from "./FormImagemProductComponent";

export default {
    name: "GaleriaImagemProductComponent",
    props: {
        product: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    prod_id: '',
                    prod_nome: '',
                }
            },
        },
        require: true,
    },

    data() {
        return {
            productPhoto: {
                require: false,
                type: Object | Array,
                default: () => {
                    return {
                        prod_ft_id: '',
                        product_id: '',
                        prod_ft_codigo: '',
                        prod_ft_foto: '',
                        prod_ft_icone: '',
                        prod_ft_desc: '',
                        prod_ft_destaque: '',
                        prod_ft_status: '',
                    }
                }
            },
            base_url: URL_BASE
        }
    },

    methods: {
        atualizarProducts() {
            this.$emit('atualiza')
        },
        destroyProductPhoto(item, index) {
            if (item.prod_ft_destaque) {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: 'Atenção!',
                    text: 'Esta foto é destaque, escolha outra como destaque antes de excluí-la',
                    showConfirmButton: true,
                    timer: 10000
                });
            } else {
                this.$swal({
                    title: 'Você tem certeza?',
                    text: "Você não poderá reverter isso",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#D32F2F',
                    cancelButtonColor: '#1976D2',
                    confirmButtonText: 'Sim, Exclua!'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('destroyProductPhoto', item.prod_ft_id)
                            .then(response => {
                                if (response.data) {
                                    this.product.fotos.splice(index, 1);
                                } else {
                                    this.$swal({
                                        position: "center",
                                        icon: "error",
                                        title: 'Opssss!',
                                        text: 'Erro ao excluir dados',
                                        showConfirmButton: true,
                                        timer: 6000
                                    });
                                }
                            })
                            .catch(error => {
                                console.log(error)
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: 'Opssss!',
                                    text: 'Algo errado aconteceu!',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            })
                    }
                })
            }

        },
        updateCapa(imagem) {
            this.$store.dispatch('updateProductPhotoCapa', {
                    prod_ft_id: imagem.prod_ft_id,
                    product_id: imagem.product_id,
                    prod_ft_destaque: true
                })
                .then((response) => {
                    this.$emit('atualiza')
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Opssss!',
                        text: 'Erro ao atualizar Capa',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {
        formImagemProduct: FormImagemProductComponent,
    }
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    max-width: 100%;
}

.is-capa {
    color: darkorange !important;
}
</style>
